import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatSnackBar, } from '@angular/material/snack-bar';
import { SnackbarData, SnackbarMessageType, SnackbarService } from '@nx-fe/services';

@Component({
  selector: 'ssp-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit, OnDestroy {

  public icon: string;
  public title: string;
  public message: string;
  onNewSnackbarSub: any;

  @ViewChild('snackbarTemplate', { static: false})
  snackbarTemplate: TemplateRef<any>;

  constructor(
    public snackbar: MatSnackBar,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.onNewSnackbarSub = this.snackbarService.onNewSnackbar.subscribe(this.onNewSnackbar);
  }

  ngOnDestroy(): void {
    if (this.onNewSnackbarSub) {
      this.onNewSnackbarSub.unsubscribe();
    }
  }

  public onNewSnackbar = (data: SnackbarData) => {
    this.title = data.title;
    this.message = data.message;

    switch (data.type) {
      case SnackbarMessageType.success:
        this.icon = 'hd-icon-selected';
        break;
      case SnackbarMessageType.failure:
        this.icon = 'hd-icon-error';
        break;
    }

    this.snackbar.openFromTemplate(this.snackbarTemplate, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: 'snack-bar-styling',
      duration: data.duration ? data.duration : 4 * 1000,
    });
  };

  public dismiss = () => {
    this.snackbar.dismiss();
  };
}
